import { BasePaths } from './constants';

export default {
    SuperHero: {
        Autotrader: `${BasePaths.Wordpress}/super-hero-at`,
    },
    EnhancedSuperHero: {
        Autotrader: `${BasePaths.Wordpress}/enhanced-super-hero-at`,
    },
};
